import React from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
import { CATALOG, Song } from '../data/songs';
function SongLine({
  song
}: {
  song: Song;
}) {
  return <span className="lowercase" data-id="element-238" data-mp="14m2ia82j6kab">{`${song.title} (${song.duration})`}</span>;
}
export function Music() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-239" data-mp="19edvgcma82kt">
      {/* Header — matches the home page exactly */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-240" data-mp="1nck6bzcf4rpc">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-241" data-mp="1sbwymzm26qzb">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-242" data-mp="3p502ixfmf41u" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-243" data-mp="3p5i6yhcfsoku">
          contact
        </a>
      </header>

      {/* Catalog: years -> releases -> songs */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-244" data-mp="1ntcuqrofd12m">
        {CATALOG.map((group, yearIdx) => <div key={group.year} className={`flex w-full flex-col items-start ${yearIdx > 0 ? 'mt-8' : ''}`} data-id="element-245" data-mp="1izrv6v76nz1b" data-mpi={yearIdx}>
            {/* Year label */}
            <p className="mb-2 font-bold lowercase" data-id="element-246" data-mp="1959pxlm4bvfe">{group.year}</p>

            {/* Releases within this year */}
            {group.releases.map((release, releaseIdx) => <div key={`${group.year}-${releaseIdx}`} className={`flex flex-col items-start gap-1 ${releaseIdx > 0 ? 'mt-4' : ''}`} data-id="element-247" data-mp="21tdwe9cikcj5" data-mpi={releaseIdx}>
                {/* Release name (only if it's a named EP / B side) */}
                {release.name && <p className="font-bold lowercase" data-id="element-248" data-mp="lecmkx8e26fr">{release.name}</p>}

                {/* Tracks */}
                {release.songs.map(song => <SongLine key={song.id} song={song} data-id="element-249" data-mp="itoe75mykvg7" />)}
              </div>)}
          </div>)}
      </section>

      {/* Footer Padding */}
      <div className="h-24" data-id="element-250" data-mp="nqoknhnq007u" />
    </main>;
}